import React from 'react'
import clsx from 'clsx'
import { FormikErrors, useFormik } from 'formik'
import * as Yup from 'yup'
import { useMutation } from '@apollo/client'
import { UpdateFranchiseAccount } from '../../../graphql/mutation'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
type Props = {
  nextStep: any
  prevStep: any
  formData: any
  setFormData: any
}

const OnboardingSchema = Yup.object().shape({
  CIN: Yup.string(),

  PAN: Yup.string(),

  TAN: Yup.string(),

  GSTIN: Yup.string()
})

const LegalInformationPage: React.FC<Props> = ({ nextStep, prevStep, formData, setFormData }) => {
  const initialValues = {
    CIN: !!formData ? formData.CIN : '',

    PAN: !!formData ? formData.PAN : '',

    TAN: !!formData ? formData.TAN : '',

    GSTIN: !!formData ? formData.GSTIN : ''
  }
  const [updateFranchiseAccount] = useMutation(UpdateFranchiseAccount, {
    context: {
      headers: {
        'access-control-allow-methods': 'Franchise'
      }
    }
  })

  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: OnboardingSchema,
    onSubmit: (values) => {
      const updatedFormData = {
        ...formData,
        CIN: values.CIN,
        PAN: values.PAN,
        TAN: values.TAN,
        GSTIN: values.GSTIN
      }

      setFormData(updatedFormData)
      updateFranchiseAccount({
        variables: {
          input: {
            id: formData.id,
            CIN: values.CIN,
            PAN: values.PAN,
            TAN: values.TAN,
            GSTIN: values.GSTIN
          }
        },
        context: {
          headers: {
            'access-control-allow-methods': 'Franchise'
          }
        }
      })
        .then((res: any) => {
          if (res.data.updateFranchiseAccount.status === 200) {
            console.log(res)
            toast.success('Legal Information Updated Successfully')
            nextStep()
          } else {
            toast.error(res.data.updateFranchiseAccount.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  })
  console.log(formData)

  const getErrorMessage = (error: string | string[] | FormikErrors<any> | FormikErrors<any>[]) => {
    if (typeof error === 'string') {
      return error
    } else if (Array.isArray(error)) {
      return error.join(', ')
    } else {
      return JSON.stringify(error)
    }
  }

  return (
    <>
      <div id='kt_account_settings_profile_details' className='collapse show'>
        <form id='kt_account_profile_details_form' className='form' onSubmit={formik.handleSubmit}>
          <div className='card-body border-top p-9'>
            <div className='row mb-6'>
              <h1 className=''>Legal Information Details</h1>
            </div>
            {formik.status && (
              <div className='mb-lg-15 alert alert-danger'>
                <div className='alert-text font-weight-bold'>{formik.status}</div>
              </div>
            )}

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label  fw-semibold fs-6'>CIN</label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('CIN')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.CIN && formik.errors.CIN
                    },
                    {
                      'is-valid': formik.touched.CIN && !formik.errors.CIN
                    }
                  )}
                  placeholder='CIN number'
                />
                {formik.touched.CIN && formik.errors.CIN && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.CIN)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-semibold fs-6'>
                <span className=''>PAN</span>
                <span
                  className='ms-1'
                  data-bs-toggle='tooltip'
                  title='Phone number must be active'
                ></span>
              </label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('PAN')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.PAN && formik.errors.PAN
                    },
                    {
                      'is-valid': formik.touched.PAN && !formik.errors.PAN
                    }
                  )}
                  placeholder='PAN number'
                />
                {formik.touched.PAN && formik.errors.PAN && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.PAN)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label fw-semibold fs-6'>TAN</label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('TAN')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.TAN && formik.errors.TAN
                    },
                    {
                      'is-valid': formik.touched.TAN && !formik.errors.TAN
                    }
                  )}
                  placeholder='TAN number'
                />
                {formik.touched.TAN && formik.errors.TAN && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.TAN)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className='row mb-6'>
              <label className='col-lg-4 col-form-label  fw-semibold fs-6'>GSTIN</label>

              <div className='col-lg-8 fv-row'>
                <input
                  type='text'
                  {...formik.getFieldProps('GSTIN')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {
                      'is-invalid': formik.touched.GSTIN && formik.errors.GSTIN
                    },
                    {
                      'is-valid': formik.touched.GSTIN && !formik.errors.GSTIN
                    }
                  )}
                  placeholder='GSTIN number'
                />
                {formik.touched.GSTIN && formik.errors.GSTIN && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert'>{getErrorMessage(formik.errors.GSTIN)}</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
            <div className='row mb-6 m-15'>
              <div className='col-lg-8 offset-lg-4'>
                <div className='d-flex justify-content-end'>
                  {/* "Next" button */}
                  <button
                    type='button'
                    className='btn btn-lg btn-secondary  mb-5 m-1'
                    onClick={prevStep}
                  >
                    Previous
                  </button>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary  mb-5 m-1'
                    disabled={formik.isSubmitting || !formik.isValid}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default LegalInformationPage
